import constants from '../../../constants';
import { getInstance } from '../../../lib/axios';

export async function GetUsersPerActivity(id) {
  try {
    const url = `${constants.endpoints.MODERATOR_USER_TRACKING}/perUsersActivity/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Users statistics fetch failed', error.message);
    throw error;
  }
}

export async function GetUsersPerDayAndMonthStatistics(id) {
  try {
    const url = `${constants.endpoints.MODERATOR_USER_TRACKING}/perDayAndMonth/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Users statistics fetch failed', error.message);
    throw error;
  }
}